// extracted by mini-css-extract-plugin
module.exports = {"customAffix":"index_customAffix__ZepeL","content":"index_content__rwPqE","closeIcon":"index_closeIcon__bsYFZ","contentInfo":"index_contentInfo__lFzh4"};